import React, { Component } from 'react'

export default class InputTextCP extends Component {
  inputType = 'text'
  
  constructor(props) {
    super(props)
  }

  render() {
    var isEditable = true // default to true
    if ('isEditable' in this.props) isEditable = this.props.isEditable
    isEditable = isEditable && this.props.meta.displayEditable

    return (
      <input {...this.props.meta.markupAttributes}
              type={this.inputType} name={this.props.objPath} className='bcioInput' 
              value={this.props.value || ''} onChange={(event => this._onChange(event))} 
              disabled={!isEditable} 
      />
    )
  }

  _onChange(event) {
    this.props.onChange(event, event.target.value, this.props.objPath)
  } 
}
